export default function(dom, opts) {
	let options = {
		baseClass: 'collapsible',
		triggerSelector: null,
		contentSelector: null,
		collapsedClass: null,
		callback: () => {},
		...opts
	};

	const triggerSelector = options.triggerSelector || `.${options.baseClass}__trigger`;
	const contentSelector = options.contentSelector || `.${options.baseClass}__content`;
	const collapsedClass = options.collapsedClass || `${options.baseClass}--collapsed`;

	const trigger = dom.querySelector(triggerSelector);
	const content = dom.querySelector(contentSelector);

	function setMaxHeight() {
		if (content) {
			content.style.maxHeight = `${content.scrollHeight}px`;
		}
	}

	function open() {
		if (dom.classList.contains(collapsedClass)) {
			return toggle();
		}
	}

	function close() {
		if (!dom.classList.contains(collapsedClass)) {
			return toggle();
		}
	}

	function toggle() {
		return new Promise(resolve => {
			content?.addEventListener('transitionend', e => {
				resolve();
			}, { once: true });

			setTimeout(() => {
				dom.classList.toggle(collapsedClass);
			}, 1);
		})
	}

	trigger?.addEventListener('click', e => {
		e.preventDefault();

		toggle();

		return false;
	});

	return {
		el: dom,
		open,
		close,
		toggle,
	}
}
